"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var create = require('nano-css').create;
var addonCssom = require('nano-css/addon/cssom').addon;
var addonPipe = require('nano-css/addon/pipe').addon;
var flattenSelectors = function (css) {
    var flatenned = {};
    var amp = {};
    var hasAmp = false;
    for (var key in css) {
        var value = css[key];
        if (typeof value === 'object') {
            flatenned[key] = value;
        }
        else {
            hasAmp = true;
            amp[key] = value;
        }
    }
    if (hasAmp) {
        flatenned['&'] = amp;
    }
    return flatenned;
};
var nano = create();
addonCssom(nano);
addonPipe(nano);
var useCss = function (css) {
    var pipe = react_1.useState(nano.pipe())[0];
    react_1.useLayoutEffect(function () {
        pipe.css(flattenSelectors(css));
        return function () { return pipe.remove(); };
    });
    return pipe.className;
};
exports.default = useCss;
